import { getCountry } from '@iwIntlProvider/CountryProvider';
import { TopUpDrawDown } from './TopupDrawdown';
import { DrawdownChoiceDE } from './DrawdownChoiceDE';

export const TopUpPanel = () => {
    if (getCountry() === 'DE') {
        return <DrawdownChoiceDE />;
    }

    return <TopUpDrawDown />;
};
